export const DEFAULT_IMAGE_PLACEHOLDER = './assets/vehicle/NoVehicle.png';
export const COOP_VEHICLE_IMAGE = './assets/vehicle/coop_vehicle_icon.png';
